import React, { FC } from "react";
import { Editor } from "@tiptap/react";
import {
  ClearButton,
  FontFormatButton,
  HeadingButton,
  LinkButton,
  ListButton,
  RedoButton,
  TextAlignButton,
  UndoButton,
} from "./ToolbarButtons";
import { ColorsTooltip } from "./ColorsTooltip";
import { HighlighterTooltip } from "./HighlighterTooltip";
import {
  FORMAT_BTNS,
  HEADING_BTNS,
  LIST_BTNS,
  TEXT_ALIGHT_BTNS,
} from "./constants/buttons";
import { HIGHLIGHT_COLORS, TEXT_COLORS } from "./constants/colors";

interface Props {
  editor: Editor;
}

export const Toolbar: FC<Props> = ({ editor }) => {
  return (
    <div className="flex gap-3 items-center px-5 py-3 relative border border-b-0 overflow-x-auto gl:overflow-x-visible border-black-base/20 rounded-t-20">
      {FORMAT_BTNS.map((btn) => (
        <FontFormatButton {...btn} key={btn.format} editor={editor} />
      ))}

      <Separator />

      {HEADING_BTNS.map((btn) => (
        <HeadingButton {...btn} key={btn.level} editor={editor} />
      ))}

      <Separator />

      {TEXT_ALIGHT_BTNS.map((btn) => (
        <TextAlignButton {...btn} key={btn.textAlign} editor={editor} />
      ))}

      <Separator />

      {LIST_BTNS.map((btn) => (
        <ListButton {...btn} key={btn.listType} editor={editor} />
      ))}

      <Separator />

      <ColorsTooltip colors={TEXT_COLORS} editor={editor} />
      <HighlighterTooltip colors={HIGHLIGHT_COLORS} editor={editor} />

      <Separator />

      <LinkButton editor={editor} />

      <Separator />

      <div className="flex gap-3 items-center justify-end flex-1">
        <UndoButton editor={editor} />
        <RedoButton editor={editor} />

        <Separator />

        <ClearButton editor={editor} />
      </div>
    </div>
  );
};

const Separator = () => {
  return <div className="border-1.5 rounded-20 h-5 border-black-base/20" />;
};
